import { decryptResponse, encryptResponse } from "../components/encryptResp";

const api_key = process.env.REACT_APP_API_KEY;

// Standardize response handling for all API calls
const handleApiResponse = async (response) => {
    try {
        const data = await response.json();
        return decryptResponse(data.encrypted, data.iv);
    } catch (error) {
        console.error('API Response Error:', error);
        return { status: false, message: "Internet Server Error" };
    }
};

const AdminAuthCheck = async () => {
    const token = localStorage.getItem('admin_quiz_app');
    try {
        const resp = await fetch('/api/app/admin/Authorization', {
            method: "GET",
            headers: {
                'x-api-key': api_key,
                'Authorization': `Bearer ${token}`,
            },
        })
        return handleApiResponse(resp);
    } catch (error) {
        console.error("Admin Auth Check" + error);
        return { status: false, message: "Internet Server Error" };
    }
}


const AdminLogin = async (body) => {
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch('/api/app/admin/login', {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': api_key
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        })
        return handleApiResponse(resp);
    } catch (error) {
        console.error("Admin Login" + error);
        return { status: false, message: "Internet Server Error" };
    }
}

const LoginOtp = async (body) => {
    const token = localStorage.getItem('token');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/admin/login/otp`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);

    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
};

const GetAdminData = async () => {
    const token = localStorage.getItem('admin_quiz_app');
    try {
        const resp = await fetch(`/api/app/admin/AdminData`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key
            },
        });
        return handleApiResponse(resp);

    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const AdminProfileUpdate = async (body) => {
    const token = localStorage.getItem('admin_quiz_app');
    const encrypted = encryptResponse(body);

    try {
        const resp = await fetch(`/api/app/admin/Profile/Update`, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key
            },
            body: JSON.stringify({ encryptedData: encrypted }),

        });
        return handleApiResponse(resp);

    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const ForgetPw = async (body) => {
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/admin/ForgetPw`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                'x-api-key': api_key
            },
            body: JSON.stringify({ encryptedData: encrypted }),

        });
        return handleApiResponse(resp);

    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
};

const ForgetPwOtp = async (body) => {
    const token = localStorage.getItem('forgetPw');
    const encrypted = encryptResponse(body);

    try {
        const resp = await fetch(`/api/app/admin/ForgetPwOtp`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                'Authorization': `Barear ${token}`,
                'x-api-key': api_key
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);

    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
};

const ResetPassword = async (body) => {
    const token = localStorage.getItem('forgetPw');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/admin/NewPassword`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                'Authorization': `Barear ${token}`,
                'x-api-key': api_key
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);

    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
};

// User Manage
const getAllUserData = async (page, startDate, endDate, limit, q, sort, block) => {
    const token = localStorage.getItem('admin_quiz_app');
    try {
        const resp = await fetch(`/api/app/user/admin/all/data?page=${page}&startDate=${startDate}&endDate=${endDate}&limit=${limit}&q=${q}&sort=${sort}&block=${block}`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },

        });
        return handleApiResponse(resp);
    } catch (error) {
        console.log(error);
        return { status: false, message: "Internet Server Error" };
    }
}

const blockUser = async (id, status) => {
    const token = localStorage.getItem('admin_quiz_app');
    const body = {
        status: status
    }
    try {
        const resp = await fetch(`/api/app/user/admin/block/${id}`, {
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body),
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.log(error);
        return { status: false, message: "Internet Server Error" };
    }
}

const deleteUser = async (body) => {
    const token = localStorage.getItem('admin_quiz_app');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/user/admin/delete`, {
            method: "DELETE",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.log(error);
        return { status: false, message: "Internet Server Error" };
    }
}

const userInfo = async (id, page, limit) => {
    const token = localStorage.getItem('admin_quiz_app');
    try {
        const resp = await fetch(`/api/app/user/admin/data/${id}?page=${page}&limit=${limit}`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.log(error);
        return { status: false, message: "Internet Server Error" };
    }
}

const updateUserInfo = async (id, body) => {
    const token = localStorage.getItem('admin_quiz_app');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/user/admin/update/${id}`, {
            method: "PUT",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.log(error);
        return { status: false, message: "Internet Server Error" };
    }
}
// User Info Ads Click Data
const userInfoAdsClick = async (id, startDate, endDate) => {
    const token = localStorage.getItem('admin_quiz_app');
    try {
        const resp = await fetch(`/api/app/user/admin/data/ads/${id}?startDate=${startDate}&endDate=${endDate}`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.log(error);
        return { status: false, message: "Internet Server Error" };
    }
}


// User Login
const getAllUserLogin = async (page, startDate, endDate, limit, q, sort) => {
    const token = localStorage.getItem('admin_quiz_app');
    try {
        const resp = await fetch(`/api/app/user/login/admin/all/data?page=${page}&startDate=${startDate}&endDate=${endDate}&limit=${limit}&q=${q}&sort=${sort}`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.log(error);
        return { status: false, message: "Internet Server Error" };
    }
}

const deleteUserLogin = async (body) => {
    const token = localStorage.getItem('admin_quiz_app');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/user/login/admin/delete`, {
            method: "DELETE",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.log(error);
        return { status: false, message: "Internet Server Error" };
    }
}

// Server Load Checker
const GetServerLoadCheck = async () => {
    const token = localStorage.getItem('admin_quiz_app');
    try {
        const resp = await fetch(`/api/app/server/load/check`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}
const uploadQuestionCSV = async (file, type) => {
    const token = localStorage.getItem('admin_quiz_app');
    const formData = new FormData();
    formData.append('file', file);
    formData.append('type', type);

    try {
        const resp = await fetch('/api/app/question/upload-csv', {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key
            },
            body: formData,
            onUploadProgress: (progressEvent) => {
                if (progressEvent.lengthComputable) {
                    const progress = Math.round((progressEvent.loaded / progressEvent.total) * 100);
                    window.dispatchEvent(new CustomEvent('uploadProgress', { detail: progress }));
                }
            }
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.error('CSV Upload Error:', error);
        return { status: false, message: 'Internet Server Error' };
    }
};

// Question
const getQuestion = async (page = 1, limit = 20, type = 'all', search = '') => {
    const token = localStorage.getItem('admin_quiz_app');

    try {
        const resp = await fetch(`/api/app/question?type=${type}&page=${page}&limit=${limit}&search=${search}`, {
            method: 'GET',
            headers: {
                'x-api-key': api_key,
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            }
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.error('Get Questions Error:', error);
        return { status: false, message: 'Internet Server Error' };
    }
};

const DeleteQuestions = async (body) => {
    const token = localStorage.getItem('admin_quiz_app');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/question/`, {
            method: "DELETE",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.log(error);
        return { status: false, message: "Internet Server Error" };
    }
}

// Quiz

const getQuiz = async (type = 'all', id = null) => {
    const token = localStorage.getItem('admin_quiz_app');

    try {
        const resp = await fetch(`/api/app/quiz/admin?type=${type}${!id ? '' : `&id=${id}`}`, {
            method: 'GET',
            headers: {
                'x-api-key': api_key,
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            }
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.error('Get Questions Error:', error);
        return { status: false, message: 'Internet Server Error' };
    }
}

const insertQuiz = async (formData) => {
    const token = localStorage.getItem('admin_quiz_app');

    try {
        const resp = await fetch('/api/app/quiz/admin', {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key
            },
            body: formData
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.error('Quiz Creation Error:', error);
        return { status: false, message: 'Internet Server Error' };
    }
};

const updateQuiz = async (id, formData) => {
    const token = localStorage.getItem('admin_quiz_app');
    try {
        const resp = await fetch(`/api/app/quiz/admin/${id}`, {
            method: 'PUT',
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key
            },
            body: formData
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.error('Quiz Creation Error:', error);
        return { status: false, message: 'Internet Server Error' };
    }
};

const deleteQuiz = async (body) => {
    const token = localStorage.getItem('admin_quiz_app');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/quiz/admin`, {
            method: "DELETE",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.log(error);
        return { status: false, message: "Internet Server Error" };
    }
}

// Policy 
const getPolicy = async () => {
    const token = localStorage.getItem('admin_quiz_app');
    try {
        const resp = await fetch(`/api/app/policy/admin/get`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },

        });
        return handleApiResponse(resp);
    } catch (error) {
        console.log(error);
        return { status: false, message: "Internet Server Error" };
    }
}

const updatePolicy = async (formData) => {
    const token = localStorage.getItem('admin_quiz_app');

    try {
        const resp = await fetch(`/api/app/policy/admin/update`, {
            method: "PUT",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
            body: formData
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.log(error);
        return { status: false, message: "Internet Server Error" };
    }
}

// Terms
const getTerms = async () => {
    const token = localStorage.getItem('admin_quiz_app');
    try {
        const resp = await fetch(`/api/app/terms/admin/get`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.log(error);
        return { status: false, message: "Internet Server Error" };
    }
}

const updateTerms = async (formData) => {
    const token = localStorage.getItem('admin_quiz_app');

    try {
        const resp = await fetch(`/api/app/terms/admin/update`, {
            method: "PUT",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
            body: formData
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.log(error);
        return { status: false, message: "Internet Server Error" };
    }
}

// contact 
const getContact = async () => {
    const token = localStorage.getItem('admin_quiz_app');
    try {
        const resp = await fetch(`/api/app/contact/admin/get`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },

        });
        return handleApiResponse(resp);
    } catch (error) {
        console.log(error);
        return { status: false, message: "Internet Server Error" };
    }
}

const updateContact = async (body) => {
    const token = localStorage.getItem('admin_quiz_app');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/contact/admin/update`, {
            method: "PUT",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.log(error);
        return { status: false, message: "Internet Server Error" };
    }
}

// Contact Us
const getContactUs = async () => {
    const token = localStorage.getItem('admin_quiz_app');
    try {
        const resp = await fetch(`/api/app/contactus/admin/get`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },

        });
        return handleApiResponse(resp);
    } catch (error) {
        console.log(error);
        return { status: false, message: "Internet Server Error" };
    }
}

const updateContactUs = async (formData) => {
    const token = localStorage.getItem('admin_quiz_app');

    try {
        const resp = await fetch(`/api/app/contactus/admin/update`, {
            method: "PUT",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
            body: formData
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.log(error);
        return { status: false, message: "Internet Server Error" };
    }
}

// Admin LeaderBoard 
const getAdminDailyDashboard = async (id, page = 1, limit = 20) => {
    const token = localStorage.getItem('admin_quiz_app');

    try {
        const resp = await fetch(`/api/app/quiz/result/admin/daily/leaderboard/${id}?page=${page}&limit=${limit}`, {
            method: 'GET',
            headers: {
                'x-api-key': api_key,
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            }
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.error('Get Questions Error:', error);
        return { status: false, message: 'Internet Server Error' };
    }
};

const getAdminLiveDashboard = async (id, page = 1, limit = 20) => {
    const token = localStorage.getItem('admin_quiz_app');

    try {
        const resp = await fetch(`/api/app/quiz/result/admin/live/leaderboard/${id}?page=${page}&limit=${limit}`, {
            method: 'GET',
            headers: {
                'x-api-key': api_key,
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            }
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.error('Get Questions Error:', error);
        return { status: false, message: 'Internet Server Error' };
    }
};

// Admin Main LeaderBoard
const getAdminMainLeaderboard = async (page = 1, limit = 20, filterType, startDate, endDate) => {
    const token = localStorage.getItem('admin_quiz_app');
    try {
        const resp = await fetch(`/api/app/quiz/result/admin/leaderboard?page=${page}&limit=${limit}&filterType=${filterType}&startDate=${startDate}&endDate=${endDate}`, {
            method: 'GET',
            headers: {
                'x-api-key': api_key,
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            }
        })
        return handleApiResponse(resp);
    } catch (error) {
        console.error('Get Questions Error:', error);
        return { status: false, message: 'Internet Server Error' };
    }
}


// Admin Delete User Account
const getuserDeleteReq = async () => {
    const token = localStorage.getItem('admin_quiz_app');
    try {
        const resp = await fetch(`/api/app/user/delete/account/req/count`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}
const getAllUserDeleteReq = async (page, q, limit) => {
    const token = localStorage.getItem('admin_quiz_app');
    try {
        const resp = await fetch(`/api/app/user/delete/account/req?page=${page}&limit=${limit}&q=${q}`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },

        });
        return handleApiResponse(resp);
    } catch (error) {
        console.log(error);
        return { status: false, message: "Internet Server Error" };
    }
}

const deleteUserreq = async (body) => {
    const token = localStorage.getItem('admin_quiz_app');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/user/admin/delete/account/req`, {
            method: "DELETE",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.log(error);
        return { status: false, message: "Internet Server Error" };
    }
}

const deleteUserreqTable = async (body) => {
    const token = localStorage.getItem('admin_quiz_app');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/user/admin/delete/account/req/table`, {
            method: "DELETE",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.log(error);
        return { status: false, message: "Internet Server Error" };
    }
}

// Web User Delete Account
const webUserDeleteAccount = async (body) => {
    const token = localStorage.getItem('admin_quiz_app');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/user/delete/account/req`, {
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// Contact Us
const getContactOption = async () => {
    const token = localStorage.getItem('admin_quiz_app');
    try {
        const resp = await fetch(`/api/app/contact/admin/`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const createContactOption = async (body) => {
    const token = localStorage.getItem('admin_quiz_app');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/contact/admin/`, {
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const updateContactOption = async (body) => {
    const token = localStorage.getItem('admin_quiz_app');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/contact/admin/`, {
            method: "PUT",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const deleteContactOption = async (body) => {
    const token = localStorage.getItem('admin_quiz_app');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/contact/admin/`, {
            method: "DELETE",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// Contact USer
const getContactUser = async () => {
    const token = localStorage.getItem('admin_quiz_app');
    try {
        const resp = await fetch(`/api/app/contact/user/`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const deleteContactUser = async (body) => {
    const token = localStorage.getItem('admin_quiz_app');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/contact/user/`, {
            method: "DELETE",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// Notification 
const getNotificationHistory = async (page, limit) => {
    const token = localStorage.getItem('admin_quiz_app');
    try {
        const resp = await fetch(`/api/app/notification/history?page=${page}&limit=${limit}`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,

            },
        });

        return handleApiResponse(resp);
    } catch (error) {
        console.log(error);
        return { status: false, message: "Internet Server Error" };
    }
}

const deleteNotification = async (body) => {
    const token = localStorage.getItem('admin_quiz_app');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/notification/delete`, {
            method: "DELETE",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.log(error);
        return { status: false, message: "Internet Server Error" };
    }
}

const sendNotification = async (formData) => {
    const token = localStorage.getItem('admin_quiz_app');
    try {
        const resp = await fetch(`/api/app/notification/send`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key
            },
            body: formData
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const ResendNotification = async (body) => {
    const token = localStorage.getItem('admin_quiz_app');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/notification/resend`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': api_key
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

//Coin  Notification 
const getCoinNotificationHistory = async (page, limit) => {
    const token = localStorage.getItem('admin_quiz_app');
    try {
        const resp = await fetch(`/api/app/notification/coin?page=${page}&limit=${limit}`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,

            },
        });

        return handleApiResponse(resp);
    } catch (error) {
        console.log(error);
        return { status: false, message: "Internet Server Error" };
    }
}

const deleteCoinNotification = async (body) => {
    const token = localStorage.getItem('admin_quiz_app');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/notification/coin/delete`, {
            method: "DELETE",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.log(error);
        return { status: false, message: "Internet Server Error" };
    }
}

const sendCoinNotification = async (formData) => {
    const token = localStorage.getItem('admin_quiz_app');
    try {
        const resp = await fetch(`/api/app/notification/coin/send`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key
            },
            body: formData
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const ResendCoinNotification = async (body) => {
    const token = localStorage.getItem('admin_quiz_app');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/notification/coin/resend`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': api_key
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// Admin Dashbord
const adminDashbord = async (startDate, endDate, type = 'all') => {
    const token = localStorage.getItem('admin_quiz_app');
    try {

        const resp = await fetch(`/api/app/admin/dashbord?startDate=${startDate}&endDate=${endDate}&type=${type}`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// Controller
const getControlleData = async () => {
    const token = localStorage.getItem('admin_quiz_app');
    try {
        const resp = await fetch(`/api/app/controller/admin/`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const updateControllerPosition = async (body) => {
    const token = localStorage.getItem('admin_quiz_app');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/controller/admin/position/update`, {
            method: 'PUT',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': api_key
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// Facebook
const setControleFacebook = async (body) => {
    const token = localStorage.getItem('admin_quiz_app');
    try {
        const resp = await fetch(`/api/app/controller/admin/fb/update`, {
            method: "PUT",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key
            },
            body: JSON.stringify(body),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// Native Ads
const getNativeAds = async () => {
    const token = localStorage.getItem('admin_quiz_app');
    try {
        const resp = await fetch(`/api/app/ads/native/admin/get`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const updateNativeAds = async (id, body) => {
    const token = localStorage.getItem('admin_quiz_app');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/ads/native/update/${id}`, {
            method: "PUT",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const addNativeAds = async (body) => {
    const token = localStorage.getItem('admin_quiz_app');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/ads/native/add`, {
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const deleteNativeAds = async (id) => {
    const token = localStorage.getItem('admin_quiz_app');
    try {
        const resp = await fetch(`/api/app/ads/native/admin/delete/${id}`, {
            method: "DELETE",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// Full Screen Ads
const getFullScreenAds = async (group = 'A') => {
    const token = localStorage.getItem('admin_quiz_app');
    try {
        const resp = await fetch(`/api/app/ads/fullScreen/admin/get?group=${group}`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const updateFullScreenAds = async (id, body) => {
    const token = localStorage.getItem('admin_quiz_app');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/ads/fullScreen/update/${id}`, {
            method: "PUT",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const addFullScreenAds = async (body) => {
    const token = localStorage.getItem('admin_quiz_app');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/ads/fullScreen/add`, {
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const deleteFullScreenAds = async (id) => {
    const token = localStorage.getItem('admin_quiz_app');
    try {
        const resp = await fetch(`/api/app/ads/fullScreen/admin/delete/${id}`, {
            method: "DELETE",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

//  Get all groups
const getFullScreenAdGroups = async () => {
    const token = localStorage.getItem('admin_quiz_app');
    try {
        const resp = await fetch(`/api/app/ads/fullScreen/admin/group/all`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
};

const cloneFullScreenAdGroup = async (body) => {
    const token = localStorage.getItem('admin_quiz_app');
    const encrypted = encryptResponse(body)
    try {
        const resp = await fetch(`/api/app/ads/fullScreen/admin/group/clone`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
};

const deleteFullScreenAdGroup = async (body) => {
    const token = localStorage.getItem('admin_quiz_app');
    const encrypted = encryptResponse(body)
    try {
        const resp = await fetch(`/api/app/ads/fullScreen/admin/group/delete`, {
            method: "DELETE",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
};

const changeFullScreenAdGroupTitle = async (body) => {
    const token = localStorage.getItem('admin_quiz_app');
    const encrypted = encryptResponse(body)
    try {
        const resp = await fetch(`/api/app/ads/fullScreen/admin/changeGroupTitle`, {
            method: "PUT",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
};


// Banner Ads
const getBannerAds = async () => {
    const token = localStorage.getItem('admin_quiz_app');
    try {
        const resp = await fetch(`/api/app/ads/banner/admin/get`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const updateBannerAds = async (id, body) => {
    const token = localStorage.getItem('admin_quiz_app');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/ads/banner/update/${id}`, {
            method: "PUT",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const addBannerAds = async (body) => {
    const token = localStorage.getItem('admin_quiz_app');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/ads/banner/add`, {
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// Analytics
const getAnalytics = async (startDate, endDate) => {
    const token = localStorage.getItem('admin_quiz_app');
    try {
        const resp = await fetch(`/api/app/analytics/admin/get?startDate=${startDate}&endDate=${endDate}`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.log(error);
        return { status: false, message: "Internet Server Error" };
    }
}


// Open Ads
const getOpenAds = async (group) => {
    const token = localStorage.getItem('admin_quiz_app');
    try {
        const resp = await fetch(`/api/app/ads/open/admin/get?group=${group}`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const addOpenAds = async (body) => {
    const token = localStorage.getItem('admin_quiz_app');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/ads/open/add`, {
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const updateOpenAds = async (id, body) => {
    const token = localStorage.getItem('admin_quiz_app');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/ads/open/update/${id}`, {
            method: "PUT",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// Open Group
const getOpenAdGroups = async () => {
    const token = localStorage.getItem('admin_quiz_app');
    try {
        const resp = await fetch(`/api/app/ads/open/admin/group/all`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
};

const cloneOpenAdGroup = async (body) => {
    const token = localStorage.getItem('admin_quiz_app');
    const encrypted = encryptResponse(body)
    try {
        const resp = await fetch(`/api/app/ads/open/admin/group/clone`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
};

const deleteOpenAdGroup = async (body) => {
    const token = localStorage.getItem('admin_quiz_app');
    const encrypted = encryptResponse(body)
    try {
        const resp = await fetch(`/api/app/ads/open/admin/group/delete`, {
            method: "DELETE",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
};

const changeOpenAdGroupTitle = async (body) => {
    const token = localStorage.getItem('admin_quiz_app');
    const encrypted = encryptResponse(body)
    try {
        const resp = await fetch(`/api/app/ads/open/admin/changeGroupTitle`, {
            method: "PUT",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
};


// Reward Ads
const getRewardAds = async () => {
    const token = localStorage.getItem('admin_quiz_app');
    try {
        const resp = await fetch(`/api/app/ads/reward/admin/get`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const addRewardAds = async (body) => {
    const token = localStorage.getItem('admin_quiz_app');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/ads/reward/add`, {
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const updateRewardAds = async (id, body) => {
    const token = localStorage.getItem('admin_quiz_app');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/ads/reward/update/${id}`, {
            method: "PUT",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const deleteRewardAds = async (id) => {
    const token = localStorage.getItem('admin_quiz_app');
    try {
        const resp = await fetch(`/api/app/ads/reward/admin/delete/${id}`, {
            method: "DELETE",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// Withdraw Coupon
const getWithdrawCoupon = async (id = null) => {
    const token = localStorage.getItem('admin_quiz_app');

    try {
        const endpoint = id ? `/api/app/withdraw/admin?id=${id}` : '/api/app/withdraw/admin';
        const resp = await fetch(endpoint, {
            method: 'GET',
            headers: {
                'x-api-key': api_key,
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.error('Get Withdraw Coupon Error:', error);
        return { status: false, message: 'Internet Server Error' };
    }
};

const insertWithdrawCoupon = async (formData) => {
    const token = localStorage.getItem('admin_quiz_app');

    try {
        const resp = await fetch('/api/app/withdraw/admin', {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key
                // Note: Don't set Content-Type when sending FormData
            },
            body: formData
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.error('Withdraw Coupon Creation Error:', error);
        return { status: false, message: 'Internet Server Error' };
    }
};

const updateWithdrawCoupon = async (id, formData) => {
    const token = localStorage.getItem('admin_quiz_app');
    try {
        const resp = await fetch(`/api/app/withdraw/admin/${id}`, {
            method: 'PUT',
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key
                // Note: Don't set Content-Type when sending FormData
            },
            body: formData
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.error('Withdraw Coupon Update Error:', error);
        return { status: false, message: 'Internet Server Error' };
    }
};

const deleteWithdrawCoupon = async (body) => {
    const token = localStorage.getItem('admin_quiz_app');
    const encrypted = encryptResponse(body);

    try {
        const resp = await fetch('/api/app/withdraw/admin', {
            method: "DELETE",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.error('Withdraw Coupon Deletion Error:', error);
        return { status: false, message: 'Internet Server Error' };
    }
};

// Withdraw Coupon Type
const getWithdrawCouponType = async () => {
    const token = localStorage.getItem('admin_quiz_app');

    try {
        const endpoint = `/api/app/withdraw/coupon/type`;
        const resp = await fetch(endpoint, {
            method: 'GET',
            headers: {
                'x-api-key': api_key,
                'Authorization': `Bearer ${token}`
            }
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.error('Get Gaid Error:', error);
        return { status: false, message: 'Internet Server Error' };
    }
}

const addWithdrawCouponType = async (body) => {
    const token = localStorage.getItem('admin_quiz_app');
    const encrypted = encryptResponse(body);
    try {
        const endpoint = `/api/app/withdraw/coupon/type`;
        const resp = await fetch(endpoint, {
            method: 'POST',
            headers: {
                'x-api-key': api_key,
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.error('Update Guid Error:', error);
        return { status: false, message: 'Internet Server Error' };
    }
}

const deleteWithdrawCouponType = async (body) => {
    const token = localStorage.getItem('admin_quiz_app');
    const encrypted = encryptResponse(body);
    try {
        const endpoint = `/api/app/withdraw/coupon/type`;
        const resp = await fetch(endpoint, {
            method: 'DELETE',
            headers: {
                'x-api-key': api_key,
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.error('Update Guid Error:', error);
        return { status: false, message: 'Internet Server Error' };
    }
}


// Withdraw Request
const rejectWithdrawRequests = async (ids, reason) => {
    const token = localStorage.getItem('admin_quiz_app');
    const body = { id: ids, reason };
    const encrypted = encryptResponse(body);

    try {
        const resp = await fetch('/api/app/withdraw/admin/request', {
            method: "DELETE",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.error('Reject Withdraw Request Error:', error);
        return { status: false, message: 'Internet Server Error' };
    }
};

// Function to get withdraw history
const getWithdrawHistory = async (page = 1, limit = 10, type = 'all', id = null) => {
    const token = localStorage.getItem('admin_quiz_app');

    try {
        const endpoint = `/api/app/withdraw/admin/request?page=${page}&limit=${limit}&type=${type}${id ? `&id=${id}` : ''}`;
        const resp = await fetch(endpoint, {
            method: 'GET',
            headers: {
                'x-api-key': api_key,
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.error('Get Withdraw History Error:', error);
        return { status: false, message: 'Internet Server Error' };
    }
};

// Function to accept withdraw request
const acceptWithdrawRequest = async (id, formData) => {
    const token = localStorage.getItem('admin_quiz_app');

    try {
        const resp = await fetch(`/api/app/withdraw/admin/request/${id}`, {
            method: "PUT",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,

            },
            body: formData,
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.error('Accept Withdraw Request Error:', error);
        return { status: false, message: 'Internet Server Error' };
    }
};

// Admin Deduct coins
const adminDeductCoins = async (body) => {
    const token = localStorage.getItem('admin_quiz_app');

    const encrypted = encryptResponse(body);

    try {
        const resp = await fetch(`/api/app/user/admin/deduct/coins`, {
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.error('Accept Withdraw Request Error:', error);
        return { status: false, message: 'Internet Server Error' };
    }
};

// Gaid
const getGuide = async () => {
    const token = localStorage.getItem('admin_quiz_app');

    try {
        const endpoint = `/api/app/guide/video/admin`;
        const resp = await fetch(endpoint, {
            method: 'GET',
            headers: {
                'x-api-key': api_key,
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.error('Get Gaid Error:', error);
        return { status: false, message: 'Internet Server Error' };
    }
}

const updateGuide = async (id, formData) => {
    const token = localStorage.getItem('admin_quiz_app');
    try {
        const endpoint = `/api/app/guide/video/admin/${id}`;
        const resp = await fetch(endpoint, {
            method: 'PUT',
            headers: {
                'x-api-key': api_key,
                'Authorization': `Bearer ${token}`
            },
            body: formData
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.error('Update Guid Error:', error);
        return { status: false, message: 'Internet Server Error' };
    }
}

// Daily Watch Ads Earn
const getDailyWatchAdsEarn = async () => {
    const token = localStorage.getItem('admin_quiz_app');
    try {
        const resp = await fetch(`/api/app/daily/watch/ads/admin`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.error('Get Daily Watch Ads Earn Error:', error);
        return { status: false, message: 'Internet Server Error' };
    }
}

const insertDailyWatchAdsEarn = async (body) => {
    const token = localStorage.getItem('admin_quiz_app');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/daily/watch/ads/admin`, {
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.error('Get Daily Watch Ads Earn Error:', error);
        return { status: false, message: 'Internet Server Error' };
    }
}

const updateDailyWatchAdsEarn = async (id, body) => {
    const token = localStorage.getItem('admin_quiz_app');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/daily/watch/ads/admin/${id}`, {
            method: "PUT",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.error('Get Daily Watch Ads Earn Error:', error);
        return { status: false, message: 'Internet Server Error' };
    }
}

const deleteDailyWatchAdsEarn = async (body) => {
    const token = localStorage.getItem('admin_quiz_app');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/daily/watch/ads/admin/`, {
            method: "DELETE",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.error('Get Daily Watch Ads Earn Error:', error);
        return { status: false, message: 'Internet Server Error' };
    }
}

// Read And Earn
const getReadAndEarn = async () => {
    const token = localStorage.getItem('admin_quiz_app');
    try {
        const resp = await fetch(`/api/app/read/admin`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.error('Get Daily Watch Ads Earn Error:', error);
        return { status: false, message: 'Internet Server Error' };
    }
}

const insertReadAndEarn = async (body) => {
    const token = localStorage.getItem('admin_quiz_app');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/read/admin`, {
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        }
        )
        return handleApiResponse(resp);
    } catch (error) {
        console.error('Get Daily Watch Ads Earn Error:', error);
        return { status: false, message: 'Internet Server Error' };
    }
}

const updateReadAndEarn = async (id, body) => {
    const token = localStorage.getItem('admin_quiz_app');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/read/admin/${id}`, {
            method: "PUT",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        })
        return handleApiResponse(resp);
    } catch (error) {
        console.error('Get Daily Watch Ads Earn Error:', error);
        return { status: false, message: 'Internet Server Error' };
    }
}

const deleteReadAndEarn = async (body) => {
    const token = localStorage.getItem('admin_quiz_app');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/read/admin/`, {
            method: "DELETE",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        })
        return handleApiResponse(resp);

    } catch (error) {
        console.error('Get Daily Watch Ads Earn Error:', error);
        return { status: false, message: 'Internet Server Error' };
    }
}

// Win Bar
const getWinbar = async () => {
    const token = localStorage.getItem('admin_quiz_app');

    try {
        const endpoint = `/api/app/winbar/admin`;
        const resp = await fetch(endpoint, {
            method: 'GET',
            headers: {
                'x-api-key': api_key,
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.error('Get Gaid Error:', error);
        return { status: false, message: 'Internet Server Error' };
    }
}

const updateWinbar = async (body) => {
    const token = localStorage.getItem('admin_quiz_app');
    const encrypted = encryptResponse(body);
    try {
        const endpoint = `/api/app/winbar/admin`;
        const resp = await fetch(endpoint, {
            method: 'PUT',
            headers: {
                'x-api-key': api_key,
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.error('Update Guid Error:', error);
        return { status: false, message: 'Internet Server Error' };
    }
}

// Quiz Non Stop
const getQuizNonStop = async () => {
    const token = localStorage.getItem('admin_quiz_app');

    try {
        const endpoint = `/api/app/quiz/non/stop/admin`;
        const resp = await fetch(endpoint, {
            method: 'GET',
            headers: {
                'x-api-key': api_key,
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.error('Get Gaid Error:', error);
        return { status: false, message: 'Internet Server Error' };
    }
}

const updateQuizNoneStop = async (body) => {
    const token = localStorage.getItem('admin_quiz_app');
    const encrypted = encryptResponse(body);
    try {
        const endpoint = `/api/app/quiz/non/stop/admin`;
        const resp = await fetch(endpoint, {
            method: 'PUT',
            headers: {
                'x-api-key': api_key,
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.error('Update Guid Error:', error);
        return { status: false, message: 'Internet Server Error' };
    }
}

// Quiz Non Stop
const getQuizWrong = async () => {
    const token = localStorage.getItem('admin_quiz_app');

    try {
        const endpoint = `/api/app/quiz/wrong/admin`;
        const resp = await fetch(endpoint, {
            method: 'GET',
            headers: {
                'x-api-key': api_key,
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.error('Get Gaid Error:', error);
        return { status: false, message: 'Internet Server Error' };
    }
}

const updateQuizWrong = async (body) => {
    const token = localStorage.getItem('admin_quiz_app');
    const encrypted = encryptResponse(body);
    try {
        const endpoint = `/api/app/quiz/wrong/admin`;
        const resp = await fetch(endpoint, {
            method: 'PUT',
            headers: {
                'x-api-key': api_key,
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.error('Update Guid Error:', error);
        return { status: false, message: 'Internet Server Error' };
    }
}

// Chat Support 
const getChatsByStatus = async (page, limit, status = 'all') => {
    const token = localStorage.getItem('admin_quiz_app');

    try {
        // Use the consolidated endpoint with status parameter
        const endpoint = `/api/app/chat/support/unread/admin?page=${page}&limit=${limit}&status=${status}`;
        const resp = await fetch(endpoint, {
            method: 'GET',
            headers: {
                'x-api-key': api_key,
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.error('Get Chats Error:', error);
        return { status: false, message: 'Internet Server Error' };
    }
};

const getChatsById = async (userId, page = 1, limit = 20) => {
    const token = localStorage.getItem('admin_quiz_app');
    try {
        const endpoint = `/api/app/chat/support/send/admin/${userId}?page=${page}&limit=${limit}&isAdmin=true`;
        const resp = await fetch(endpoint, {
            method: 'GET',
            headers: {
                'x-api-key': api_key,
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.error('Get Chat Messages Error:', error);
        return { status: false, message: 'Internet Server Error' };
    }
};

const sendUserChat = async (formData) => {
    const token = localStorage.getItem('admin_quiz_app');
    try {
        const endpoint = `/api/app/chat/support/send/admin`;
        const resp = await fetch(endpoint, {
            method: 'POST',
            headers: {
                'x-api-key': api_key,
                'Authorization': `Bearer ${token}`,
            },
            body: formData,
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.error('Update Guid Error:', error);
        return { status: false, message: 'Internet Server Error' };
    }
}

const deleteChat = async (body) => {
    const token = localStorage.getItem('admin_quiz_app');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/chat/support/delete`, {
            method: "DELETE",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.log(error);
        return { status: false, message: "Internet Server Error" };
    }
}

// TapToEar
const getTapToEarn = async () => {
    const token = localStorage.getItem('admin_quiz_app');
    try {
        const resp = await fetch(`/api/app/tap/earn/admin`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.error('Get Daily Watch Ads Earn Error:', error);
        return { status: false, message: 'Internet Server Error' };
    }
}

const putTapToEarn = async (body) => {
    const token = localStorage.getItem('admin_quiz_app');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/tap/earn/admin`, {
            method: "PUT",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.error('Get Daily Watch Ads Earn Error:', error);
        return { status: false, message: 'Internet Server Error' };
    }
}

// Who is Beautiful
const getWhois = async (option, page = 1, limit = 20) => {
    const token = localStorage.getItem('admin_quiz_app');
    try {
        const endpoint = `/api/app/whois/admin?page=${page}&limit=${limit}&option=${option}`;
        const resp = await fetch(endpoint, {
            method: 'GET',
            headers: {
                'x-api-key': api_key,
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.error('Get Chat Messages Error:', error);
        return { status: false, message: 'Internet Server Error' };
    }
};

const insertWhois = async (formData) => {
    const token = localStorage.getItem('admin_quiz_app');
    try {
        const endpoint = `/api/app/whois/admin`;
        const resp = await fetch(endpoint, {
            method: 'POST',
            headers: {
                'x-api-key': api_key,
                'Authorization': `Bearer ${token}`,
            },
            body: formData,
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.error('Update Guid Error:', error);
        return { status: false, message: 'Internet Server Error' };
    }
}

const deleteWhois = async (body) => {
    const token = localStorage.getItem('admin_quiz_app');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/whois/admin`, {
            method: "DELETE",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.log(error);
        return { status: false, message: "Internet Server Error" };
    }
}

// Who is Beautiful controles
const getWhoisControle = async () => {
    const token = localStorage.getItem('admin_quiz_app');
    try {
        const resp = await fetch(`/api/app/whois/controles/admin`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.error('Get Daily Watch Ads Earn Error:', error);
        return { status: false, message: 'Internet Server Error' };
    }
}

const putWhoisControle = async (body) => {
    const token = localStorage.getItem('admin_quiz_app');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/whois/controles/admin`, {
            method: "PUT",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.error('Get Daily Watch Ads Earn Error:', error);
        return { status: false, message: 'Internet Server Error' };
    }
}

// In House Ads
const uploadInHouseAds = async (formData) => {
    const token = localStorage.getItem('admin_quiz_app');
    try {
        const resp = await fetch(`/api/app/ads/inhouse`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key
            },
            body: formData
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const getInHouseAds = async (page, limit, q) => {
    const token = localStorage.getItem('admin_quiz_app');
    try {
        const resp = await fetch(`/api/app/ads/inhouse?a=true&page=${page}&limit=${limit}&q=${q}`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            }
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const getInHouseAdsDashboard = async (startDate, endDate) => {
    const token = localStorage.getItem('admin_quiz_app');
    try {
        const resp = await fetch(`/api/app/ads/inhouse/dashboard?startDate=${startDate}&endDate=${endDate}`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            }
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const setInHouseAdsStatus = async (id, status) => {
    const token = localStorage.getItem('admin_quiz_app');
    try {
        const body = {
            id,
            status
        }
        const resp = await fetch(`/api/app/ads/inhouse/update/status`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`, // Corrected 'Bearer'
                'x-api-key': api_key
            },
            body: JSON.stringify(body),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const deleteInhouseAds = async (body) => {
    const token = localStorage.getItem('admin_quiz_app');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/ads/inhouse`, {
            method: "DELETE",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.log(error);
        return { status: false, message: "Internet Server Error" };
    }
}

const getInHouseAdsData = async (id) => {
    const token = localStorage.getItem('admin_quiz_app');
    try {
        const resp = await fetch(`/api/app/ads/inhouse/data/${id}`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            }
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const updateInHouseAds = async (formData) => {
    const token = localStorage.getItem('admin_quiz_app');
    try {
        const resp = await fetch(`/api/app/ads/inhouse`, {
            method: 'PUT',
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key
            },
            body: formData
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// Admin Views Dashbord and Click Dashbord
const adminViewsDashbord = async (id, startDate, endDate) => {
    const token = localStorage.getItem('admin_quiz_app');
    try {

        const resp = await fetch(`/api/app/admin/view/dashbord/${id}?startDate=${startDate}&endDate=${endDate}`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.log(error);
        return { status: false, message: "Internet Server Error" };
    }
}


// Ads Earn Model 
const getAdsSetting = async () => {
    const token = localStorage.getItem('admin_quiz_app');

    try {
        const endpoint = `/api/app/ads/earn/admin/setting`;
        const resp = await fetch(endpoint, {
            method: 'GET',
            headers: {
                'x-api-key': api_key,
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.error('Get Gaid Error:', error);
        return { status: false, message: 'Internet Server Error' };
    }
}

const updateAdsSetting = async (body) => {
    const token = localStorage.getItem('admin_quiz_app');
    const encrypted = encryptResponse(body);
    try {
        const endpoint = `/api/app/ads/earn/admin/setting`;
        const resp = await fetch(endpoint, {
            method: 'PUT',
            headers: {
                'x-api-key': api_key,
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.error('Update Guid Error:', error);
        return { status: false, message: 'Internet Server Error' };
    }
}

// Check Old user 
const getTodayUniqueQuizPlayerAge = async (page, limit, startDate, endDate) => {
    const token = localStorage.getItem('admin_quiz_app');
    try {
        const resp = await fetch(`/api/app/user/login/admin/restrive?page=${page}&limit=${limit}&startDate=${startDate}&endDate=${endDate}`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.error('Get Daily Watch Ads Earn Error:', error);
        return { status: false, message: 'Internet Server Error' };
    }
}

// Game
const addGame = async (formData) => {
    const token = localStorage.getItem('admin_quiz_app');
    try {
        const resp = await fetch(`/api/app/game/admin`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key
            },
            body: formData
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const getGame = async (page, limit, q, sort, sortField) => {
    const token = localStorage.getItem('admin_quiz_app');
    try {
        const resp = await fetch(`/api/app/game/admin?&page=${page}&limit=${limit}&q=${q}&sort=${sort}&sortField=${sortField}`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            }
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const deleteGame = async (body) => {
    const token = localStorage.getItem('admin_quiz_app');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/game/admin`, {
            method: "DELETE",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.log(error);
        return { status: false, message: "Internet Server Error" };
    }
}

const updateGame = async (formData, id) => {
    const token = localStorage.getItem('admin_quiz_app');
    try {
        const resp = await fetch(`/api/app/game/admin/${id}`, {
            method: 'PUT',
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key
            },
            body: formData
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// Reels
const getReels = async (page = 1, limit = 10, search = '') => {
    const token = localStorage.getItem('admin_quiz_app');
    try {
        const resp = await fetch(`/api/app/reels/admin?page=${page}&limit=${limit}&search=${search}`, {
            method: 'GET',
            headers: {
                'x-api-key': api_key,
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            }
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.error('Get Reels Error:', error);
        return { status: false, message: 'Internet Server Error' };
    }
};

const addReels = async (formData) => {
    const token = localStorage.getItem('admin_quiz_app');
    try {
        const resp = await fetch('/api/app/reels/admin', {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key
                // Note: Don't set Content-Type when sending FormData
            },
            body: formData
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.error('Add Reels Error:', error);
        return { status: false, message: 'Internet Server Error' };
    }
};

const deleteReels = async (body) => {
    const token = localStorage.getItem('admin_quiz_app');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch('/api/app/reels/admin', {
            method: 'DELETE',
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.error('Delete Reels Error:', error);
        return { status: false, message: 'Internet Server Error' };
    }
};

const getReelsSetting = async () => {
    const token = localStorage.getItem('admin_quiz_app');
    try {
        const resp = await fetch('/api/app/reels/setting/admin', {
            method: 'GET',
            headers: {
                'x-api-key': api_key,
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            }
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.error('Get Reels Setting Error:', error);
        return { status: false, message: 'Internet Server Error' };
    }
};

const updateReelsSetting = async (body) => {
    const token = localStorage.getItem('admin_quiz_app');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch('/api/app/reels/setting/admin', {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.error('Update Reels Setting Error:', error);
        return { status: false, message: 'Internet Server Error' };
    }
};

const Calling = {
    AdminLogin, AdminAuthCheck, ResetPassword, LoginOtp, GetAdminData, AdminProfileUpdate, ForgetPw, ForgetPwOtp,
    getAllUserData, blockUser, deleteUser, userInfo, updateUserInfo,
    getAllUserLogin, deleteUserLogin, GetServerLoadCheck, uploadQuestionCSV, getQuestion, DeleteQuestions,
    insertQuiz, getQuiz,
    deleteQuiz, updateQuiz,
    getPolicy, updatePolicy, getTerms, updateTerms, getContact, updateContact, getContactUs, updateContactUs,
    getAdminDailyDashboard, getAdminLiveDashboard,
    getAdminMainLeaderboard,
    getuserDeleteReq, deleteUserreq, deleteUserreqTable, getAllUserDeleteReq, webUserDeleteAccount,
    getContactOption, createContactOption, updateContactOption, deleteContactOption,
    getContactUser, deleteContactUser,
    getNotificationHistory, deleteNotification, sendNotification, ResendNotification,
    getCoinNotificationHistory, deleteCoinNotification, sendCoinNotification, ResendCoinNotification,
    adminDashbord,
    getControlleData, setControleFacebook,
    getNativeAds, updateNativeAds, addNativeAds, deleteNativeAds,
    getFullScreenAds, updateFullScreenAds, addFullScreenAds, deleteFullScreenAds,
    getBannerAds, updateBannerAds, addBannerAds,
    getOpenAds, updateOpenAds, addOpenAds,
    getRewardAds, updateRewardAds, addRewardAds, deleteRewardAds,
    getAnalytics,
    getWithdrawCoupon, insertWithdrawCoupon, updateWithdrawCoupon, deleteWithdrawCoupon,
    getWithdrawHistory, acceptWithdrawRequest, rejectWithdrawRequests,
    adminDeductCoins,
    updateControllerPosition,
    getGuide, updateGuide,
    getDailyWatchAdsEarn, insertDailyWatchAdsEarn, updateDailyWatchAdsEarn, deleteDailyWatchAdsEarn,
    getReadAndEarn, insertReadAndEarn, updateReadAndEarn, deleteReadAndEarn,
    getWinbar, updateWinbar,
    getWithdrawCouponType, addWithdrawCouponType, deleteWithdrawCouponType,
    getQuizNonStop, updateQuizNoneStop,
    getChatsByStatus, sendUserChat, getChatsById, deleteChat,
    getTapToEarn, putTapToEarn,
    getQuizWrong, updateQuizWrong,
    getWhois, insertWhois, deleteWhois,
    getWhoisControle, putWhoisControle,
    uploadInHouseAds, getInHouseAdsData, deleteInhouseAds, setInHouseAdsStatus, getInHouseAds, updateInHouseAds, adminViewsDashbord, getInHouseAdsDashboard,
    getAdsSetting, updateAdsSetting, userInfoAdsClick, getTodayUniqueQuizPlayerAge,
    cloneFullScreenAdGroup, getFullScreenAdGroups, deleteFullScreenAdGroup, changeFullScreenAdGroupTitle,
    changeOpenAdGroupTitle, deleteOpenAdGroup, cloneOpenAdGroup, getOpenAdGroups,
    addGame, updateGame, deleteGame, getGame,
    getReels, addReels, deleteReels, getReelsSetting, updateReelsSetting
}


export default Calling;


